import { render, staticRenderFns } from "./BucketPreview.vue?vue&type=template&id=6a9611fc&scoped=true&"
import script from "./BucketPreview.vue?vue&type=script&lang=ts&"
export * from "./BucketPreview.vue?vue&type=script&lang=ts&"
import style0 from "./BucketPreview.vue?vue&type=style&index=0&id=6a9611fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9611fc",
  null
  
)

export default component.exports